import type { ParcelTypeDto } from '~/common/model/capabilities'
import { useDataAsyncCall } from '~/api/admin-api'

export const useParcelTypes = (businessUnit: string, fromCountry: string) => {
  const [parcelTypes, { isLoading }] = useDataAsyncCall<ParcelTypeDto[]>(
    `parcel-types?fromCountry=${fromCountry}&businessUnit=${businessUnit}`
  )
  return { parcelTypes: parcelTypes ?? [], isLoading }
}
